
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";
import { assignedBoundryDetails } from "../slice/adminMapSlice";

const useAssignedRoute = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();

  const setAssignedRoute = async (param) => {
    try {
      const response = await Axios.post("get_boundary_data", param);
      const data = response.data;
      dispatch(assignedBoundryDetails(data));
      console.log(data);
      return data;  
    } catch (error) {
      console.error("Error fetching admin map data:", error);
      throw error;  
    }
  };
  return setAssignedRoute;
};

export default useAssignedRoute;